import state from './moduleRelationshipRuleCategoryState'
import actions from './moduleRelationshipRuleCategoryActions'
import getters from './moduleRelationshipRuleCategoryGetters'
import mutations from './moduleRelationshipRuleCategoryMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
